import type Application from './package/base/Application';

// Export synchronously as the default.
const App = {
  instance: {} as Application,
  // This helps downstream consumers who can use async/await.
  ready: new Promise<Application>(() => {}), // Initial dummy promise
};

async function selectCasinoAndLoad() {
  const label = window._appConfig?.label;
  window.$app.logger.log('[app config] label:', label);

  let AppClass: { default: new () => Application };
  try {
    if (label === 'games') {
      AppClass = await import('./package/casino-de/CasinoDE_games');
    } else if (label === 'casino') {
      AppClass = await import('./package/casino-de/CasinoDE_casino');
    } else {
      AppClass = await import('./package/casino-de/CasinoDE');
    }
  } catch (err) {
    // Dynamic import failed — likely stale cached index.html referencing
    // hashed bundles that no longer exist after a deployment. Force a
    // clean reload to fetch the current index.html and assets (IGM-3644).
    window.$app.logger.error('Failed to load app bundle — reloading', err);
    await new Promise((r) => setTimeout(r, 2000));
    window.location.reload();
    return;
  }

  // Instantiate class and set synchronous export.
  const loadedInstance = new AppClass.default();
  App.instance = loadedInstance;

  // Yield to main thread before resolving App.ready — allows the browser
  // to process paint and input events between constructor work and the
  // downstream initialization triggered by App.ready resolution.
  await new Promise((resolve) => setTimeout(resolve, 0));

  (App.ready as any)._resolve(loadedInstance);

  return loadedInstance;
}

let resolveAppReady: (value: Application) => void;
App.ready = new Promise<Application>((resolve) => {
  resolveAppReady = resolve;
});
(App.ready as any)._resolve = resolveAppReady!;

// Wait for DOM to be ready before attempting dynamic imports
// document.addEventListener('DOMContentLoaded', () => {
setTimeout(() => {
  selectCasinoAndLoad();
}, 0);

// Catch failed lazy chunk imports (e.g. after deployment replaces hashed bundles).
// Triggers a reload so the user gets the current version instead of a broken page (IGM-3644).
window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const msg = String(event.reason?.message ?? event.reason ?? '');
  if (msg.includes('Failed to fetch dynamically imported module') || msg.includes('Importing a module script failed')) {
    window.$app.logger.error('Lazy chunk import failed — reloading', msg);
    event.preventDefault();
    setTimeout(() => window.location.reload(), 2000);
  }
});

// Export the synchronous object as default.
// Existing imports will continue to work: `import instance from './module';`
export default App;
